$('.graphs-aggregation').ready(function () {
    $('.agen-graphs').hover(function () {
        $(this).siblings('.data_entry_mini_block_link').addClass('hover-together');
    }, function () {
        $(this).siblings('.data_entry_mini_block_link').removeClass('hover-together');
    });

    $('.data_entry_mini_block_link').hover(function () {
        $(this).siblings('.agen-graphs').addClass('hover-together');
    }, function () {
        $(this).siblings('.agen-graphs').removeClass('hover-together');
    });

    $('.agen-data-graph-overlay').hover(function () {
        $(this).parents('.agen-graphs').addClass('hover-together');
    }, function () {
        $(this).parents('.agen-graphs').removeClass('hover-together');
    });
});

$(document).ready(function () {
    var gID = $('.active-graph').attr( 'id' );
    $('div#graph_'+gID+'.fade.in.active.agen-data-graph').parents('.graphs-aggregation').addClass('active');
    $('div#table_'+gID+'.fade.agen-data-table').parents('.graphs-aggregation').addClass('active');
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/DataEntryAgregat/DataEntryAgregat.js
// module id = 24
// module chunks = 0